import React, { useState, useEffect, useRef } from "react";
import { AgCharts } from "ag-charts-community";

// React Chart Component
const PlanChart = (props) => {
  const chartDivRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const xKeyLabel = props.xKeyLabel || 'month';

  const [options, setOptions] = useState({ data: [], series: [
    { type: "line", xKey: xKeyLabel, yKey: "Sales", yName: "Sales Plan", marker: { fill: "#008000", stroke: "#008000" }, stroke: "#008000" },
    { type: "area", xKey: xKeyLabel, yKey: "Inventory", yName: "Inventory BOM", fill: "yellow", fillOpacity: 0.5 },
    { type: "line", xKey: xKeyLabel, yKey: "invInfPlanRetail", yName: "Plan Inf Retail", marker: { fill: "#800080", stroke: "#800080" }, stroke: "#800080" },
    { type: "line", xKey: xKeyLabel, yKey: "Markdowns", yName: "Markdowns Plan", marker: { fill: "#FF0000", stroke: "#FF0000" }, stroke: "#FF0000" },
  ], axes: [
    { type: "category", position: "bottom", label: { rotation: 45 } },
    { type: "number", position: "left", label: { enabled: false } },
  ], legend: { enabled: false } });

  useEffect(() => {
    // Read fresh values inside the effect to avoid stale closure.
    const salesPlan = props.chartData?.get("SalesPlan") ?? [];
    const inventoryBom = props.chartData?.get("InventoryBomPlan") ?? [];
    const markdownPlan = props.chartData?.get("MarkdownsPlan") ?? [];
    const invInfPlanRetail = props.chartData?.get("InflowPlanRetail") ?? [];
    const labels = props.labels || props.displayMonths || [];
    const xKey = props.xKeyLabel || 'month';

    const data = labels.map((label, index) => ({
      [xKey]: label,
      Sales: salesPlan[index] ? salesPlan[index] / 1000 : 0,
      Inventory: inventoryBom[index] ? inventoryBom[index] / 1000 : 0,
      invInfPlanRetail: invInfPlanRetail[index] ? invInfPlanRetail[index] / 1000 : 0,
      Markdowns: markdownPlan[index] ? markdownPlan[index] / 1000 : 0,
    }));

    setOptions(prev => ({ ...prev, data }));
  }, [props.chartData, props.labels, props.displayMonths, props.xKeyLabel]);

  // Create / update chart imperatively
  useEffect(() => {
    if (!chartDivRef.current) return;
    if (chartInstanceRef.current) {
      // Update existing chart
      chartInstanceRef.current.update(options);
    } else {
      chartInstanceRef.current = AgCharts.create({
        container: chartDivRef.current,
        ...options,
      });
    }
    return () => {
      // Cleanup when component unmounts (avoid memory leaks on HMR)
      if (chartInstanceRef.current && chartDivRef.current) {
        try { chartInstanceRef.current.destroy?.(); } catch (e) { /* ignore */ }
        chartInstanceRef.current = null;
      }
    };
  }, [options]);

  return <div ref={chartDivRef} style={{ width: "110%", height: 250 }} />;
};

export default PlanChart;
